(function(){
    'use strict';
    angular.module('Directives').directive('scrollableList', function(){
        return {
            restrict: 'E',
            scope: {
                class: '=?',
                marginTop: '=?',
                height: '=?',
                width: '=?',
                ngModel: '=',
                noDataMsg: '=?',
                withRemove: '=?',
                onClickHandle: '=?'
            },
            templateUrl: '/templates/directives/scrollable-list.html',
            link: scrollableListLink
        }

        function scrollableListLink($scope) {
            $scope.cssStyle ={
                'height' : `${$scope.height}px`,
                'margin-top' : `${$scope.marginTop}px`
            }

            $scope.$watch('ngModel', (val)=>{
                $scope.list = $scope.ngModel; 
            });
           
            $scope.noDataMsg = $scope.noDataMsg ? $scope.noDataMsg : 'No Data found';
        }
    });
})()


// WEBPACK FOOTER //
// ./js/directives/scrollableList.js